module.exports = __webpack_public_path__ + "media/src/images/partners/eu_institute-881be13fab8003539245fb4200d3bfd8.jpg";